import i18n from '@/libs/i18n'

export default [
  {
    path: '/user-lists',
    name: 'user-lists',
    component: () => import('@/views/pages/management/users/table/Lists.vue'),
    meta: {
      pageTitle: i18n.t('User Lists'),
      breadcrumb: [
        // {
        //   text: i18n.t('User'),
        // },
        // {
        //   text: i18n.t('User Lists'),
        //   active: true,
        // },
      ],
    },
    props:{
      linkForGroup: "user-lists"
    }
  },
  {
    path: '/user-lists-add',
    name: 'user-lists-add',
    component: () => import('@/views/pages/management/users/form/Add.vue'),
    meta: {
      pageTitle: i18n.t('User Add'),
      breadcrumb: [
        // {
        //   text: i18n.t('User'),
        // },
        {
          text: i18n.t('User List'),
          to: { name: 'user-lists' },
        },
        {
          text: i18n.t('User Add'),
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-lists-detail/:id',
    name: 'user-lists-detail',
    component: () => import('@/views/pages/management/users/form/Profile.vue'),
    meta: {
      pageTitle: i18n.t('User Detail'),
      breadcrumb: [
        // {
        //   text: i18n.t('User'),
        // },
        {
          text: i18n.t('User List'),
          to: { name: 'user-lists' },
        },
        {
          text: i18n.t('User Detail'),
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-lists-edit-password/:id',
    name: 'user-lists-edit-password',
    component: () => import('@/views/pages/management/users/form/Edit.vue'),
    meta: {
      pageTitle: i18n.t('Edit Password'),
      breadcrumb: [
        // {
        //   text: i18n.t('User'),
        // },
        {
          text: i18n.t('User List'),
          to: { name: 'user-lists' },
        },
        {
          text: i18n.t('User Detail'),
        },
        {
          text: i18n.t('Edit Password'),
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-lists-edit/:id',
    name: 'user-lists-edit',
    component: () => import('@/views/pages/management/users/form/Edit_infor.vue'),
    meta: {
      pageTitle: i18n.t('Edit infor'),
      breadcrumb: [
        // {
        //   text: i18n.t('User'),
        // },
        {
          text: i18n.t('User List'),
          to: { name: 'user-lists' },
        },
        {
          text: i18n.t('User Detail'),
        },
        {
          text: i18n.t('Edit infor'),
          active: true,
        },
      ],
    },
  },
  {
    path: '/role',
    name: 'role',
    component: () => import('@/views/pages/management/roleApp/table/Lists.vue'),
    meta: {
      pageTitle: i18n.t('Role Lists'),
      breadcrumb: [
        // {
        //   text: i18n.t('Role'),
        // },
        // {
        //   text: i18n.t('Role Lists'),
        //   active: true,
        // },
      ],
    },
  },
  {
    path: '/role-add',
    name: 'role-add',
    component: () => import('@/views/pages/management/roleApp/form/Add.vue'),
    meta: {
      pageTitle: i18n.t('Role Add'),
      breadcrumb: [
        // {
        //   text: i18n.t('Role'),
        // },
        {
          text: i18n.t('Role Lists'),
          to: { name: 'role' },
        },
        {
          text: i18n.t('Role Add'),
          active: true,
        },
      ],
    },
  },
  {
    path: '/role-edit/:id',
    name: 'role-edit',
    component: () => import('@/views/pages/management/roleApp/form/Edit.vue'),
    meta: {
      pageTitle: i18n.t('Role Edit'),
      breadcrumb: [
        {
          text: i18n.t('Role'),
        },
        {
          text: i18n.t('Role Lists'),
          to: { name: 'role' },
        },
        {
          text: i18n.t('Role Edit'),
          active: true,
        },
      ],
    },
  },
  {
    path: '/role-detail/:id',
    name: 'role-detail',
    component: () => import('@/views/pages/management/roleApp/form/Detail.vue'),
    meta: {
      pageTitle: i18n.t('Role Detail'),
      breadcrumb: [
        {
          text: i18n.t('Role'),
        },
        {
          text: i18n.t('Role Lists'),
          to: { name: 'role' },
        },
        {
          text: i18n.t('Role Detail'),
          active: true,
        },
      ],
    },
  },
]
